/**
 * MypageSubscribeDetailsContainer
 * --
 */
import React from 'react';
import MypageSubscribeDetailsPresenter from './MypageSubscribeDetailsPresenter';

const MypageSubscribeDetailsContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <MypageSubscribeDetailsPresenter />
    </>
  );
};

export default MypageSubscribeDetailsContainer;
